import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sortBy" }
const _hoisted_2 = {
  class: "sortOptionsWrapper",
  id: "sortButtonControl",
  role: "region",
  "aria-labelledby": "sortButtonID",
  "aria-hidden": "true",
  ref: "sortByPanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortOrderDropDownOption = _resolveComponent("SortOrderDropDownOption")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "sortByButton",
      "aria-expanded": "false",
      "aria-controls": "sortButtonControl",
      id: "sortButtonID",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sortByClick && _ctx.sortByClick(...args))),
      ref: "sortByButton"
    }, _toDisplayString(_ctx.$t("Web.Containers.SortOrder.Title")), 513),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (sortOrderOption) => {
        return (_openBlock(), _createBlock(_component_SortOrderDropDownOption, {
          class: "sortByOption",
          key: sortOrderOption.key,
          optionValue: sortOrderOption,
          isSelected: 
          sortOrderOption.key === _ctx.selectedOption?.key &&
            sortOrderOption.isDescending === _ctx.selectedOption?.isDescending
        ,
          onSortChanged: _ctx.updateSelectedValue
        }, null, 8, ["optionValue", "isSelected", "onSortChanged"]))
      }), 128))
    ])), [
      [_directive_click_outside, _ctx.clickOutsideSortByPanel]
    ])
  ]))
}